import LogoWebp from '../../assets/img/vm-logo-196.webp';

/**
 * The CMS logo can be much larger than the bundled brand mark.
 * By default we use the bundled WebP for the app shell and allow
 * an explicit opt-in switch when a dynamic logo is required.
 */
export const getSiteLogoUrl = (dynamicLogo?: string) => {
  if (process.env.REACT_APP_USE_DYNAMIC_LOGO === 'true' && dynamicLogo) {
    return dynamicLogo;
  }

  return LogoWebp;
};

